import {React, useEffect } from "react";
// import HeartScene from "./BrainScene";
import ButtonLink from "./ButtonLink";
import { Link } from "react-router-dom";
import Transitions from "./Transitions";
import { SectionHeader } from "./Header";
import { HighlightCard } from "./WorkCard";
import TEEimg from "../img/TEE_mockup.png";
import NeuroImg from "../img/neuro_demo.gif";
import { Helmet } from "react-helmet";

import ContactCTA from "./ContactCTA";

// const item = {
//   initial: { y: 50, opacity: 0 },
//   animate: {
//     y: 0,
//     opacity: 1,
//     transition: {
//       duration: 1.0,
//       ease: [0.6, 0.01, -0.05, 0.95],
//     },
//   },
// };

function Home() {
  useEffect(() => {
    // let info = [
    //   "medical illustrator",
    //   "animator",
    //   "UX designer",
    //   "technologist",
    // ];
    // let i = 0;
    // let intervalId = setInterval(function () {
    //   document.querySelector(".scivis").innerHTML = " " + info[i] + " ";
    //   if (i == info.length - 1) {
    //     i = 0;
    //   } else {
    //     i++;

    //   }
    // }, 5000);
    // document.title = "ETCHNG";  




    var _CONTENT = [ 
      "a medical illustrator",
      "an animator",
      "a UX designer",
      "a technologist",
    ];
    
    // Current sentence being processed
    var _PART = 0;
    
    // Character number of the current sentence being processed 
    var _PART_INDEX = 0;
    
    // Holds the handle returned from setInterval
    var _INTERVAL_VAL;
    
    // Element that holds the text
    var _ELEMENT = document.querySelector(".scivis");
    
    // Cursor element 
    // var _CURSOR = document.querySelector("#cursor");
    
    // Implements typing effect
    function Type() { 
      // Get substring with 1 characater added
      var text =  _CONTENT[_PART].substring(0, _PART_INDEX + 1);
      _ELEMENT.innerHTML = text;
      _PART_INDEX++;
    
      // If full sentence has been displayed then start to delete the sentence after some time
      if(text === _CONTENT[_PART]) {
        // Hide the cursor
        // _CURSOR.style.display = 'none';
    
        clearInterval(_INTERVAL_VAL);
        setTimeout(function() {
          _INTERVAL_VAL = setInterval(Delete, 50);
        }, 1000);
      }
    }
    
    // Implements deleting effect
    function Delete() {
      // Get substring with 1 characater deleted
      var text =  _CONTENT[_PART].substring(0, _PART_INDEX - 1);
      _ELEMENT.innerHTML = text;
      _PART_INDEX--;
    
      // If sentence has been deleted then start to display the next sentence
      if(text === '') {
        clearInterval(_INTERVAL_VAL);
    
        // If current sentence was last then display the first one, else move to the next
        if(_PART === (_CONTENT.length - 1))
          _PART = 0;
        else
          _PART++;
        
        _PART_INDEX = 0;
    
        // Start to display the next sentence after some time
        setTimeout(function() {
          // _CURSOR.style.display = 'inline-block';
          _INTERVAL_VAL = setInterval(Type, 100);
        }, 200);
      }
    }
    
    // Start the typing effect on load
    _INTERVAL_VAL = setInterval(Type, 100);
  }, []);
  return (
    <div>
      <Helmet>
        <title>ETCHNG</title>
        <meta name="description" content="Eric Chung's Portfolio Homepage"/> 
        <meta name="keywords" content="ETCHNG, Eric Chung, medical illustrator, UI/UX, 3D, Unity"
        />
    </Helmet>
      <Transitions>
        {/* <HeartScene /> */}


        
        <div className="wrapper">
          <section className="main">
            <div className="main__herotext">
              <h1>
                <span>SCIENCE</span>
              </h1>
              <h1>
                <div style={{ display: "flex" }}>
                  <div className="dash"></div>
                  <span className="hollow"> MADE</span>{" "}
                </div>
                {/* <span className="dash">-</span> */}
              </h1>
              <h1>
                <span>SALIENT</span>
              </h1>
              <div className="diagonalWrap">
                <svg
                  width="310"
                  height="333"
                  viewBox="0 0 310 333"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="diagonal2">
                    <line
                      id="Line 30"
                      x1="0.646447"
                      y1="308.988"
                      x2="308.988"
                      y2="0.646433"
                      stroke="#F55A59"
                    />
                    <line
                      id="Line 33"
                      x1="0.646447"
                      y1="332.646"
                      x2="308.988"
                      y2="24.3044"
                      stroke="#F55A59"
                    />
                  </g>
                </svg>
              </div>

            </div>{" "}
            <div className="main__valueprop ">
              <div style={{width:'17rem',display:'flex', flexDirection:'column'}}>
              <p>Hi, I'm Eric...</p>
              <div className="typeContainer">
              <h4>
                <span className="scivis">medical illustrator</span> 
              </h4><div id="cursor"></div></div>
              <p>
                specializing in creative solutions for healthcare & science.
              </p>

            </div>            
            {/* <div className="btn__wrap"><ButtonLink>LEARN MORE</ButtonLink></div>  */}
</div>
            {/* <div className="blend-mask"></div> */}
          </section>
          <section className="highlights">
            <SectionHeader
              textColour="#f55a59"
              smallText="Featured"
              largeText="HIGHLIGHTS"
            ></SectionHeader>
            <Link to="/work/TEEsim">
              <HighlightCard
                photo_icon={TEEimg}
                photo_alt="TEE"
                name="Developing a transesophageal echocardiography simulator for medical education"
                category="UI/UX |  3D | Animation"
                type="Web app"
              />{" "}
            </Link>
            <Link to="/work/MediapipeNeuro">
              <HighlightCard
                photo_icon={NeuroImg}
                photo_alt="TEE"
                name="Using machine learning to create a gesture-controlled neuroanatomy atlas              "
                category="UI/UX |  3D "
                type="Web app"
              />{" "}
            </Link>
            <div className="btn__wrap">
              <Link to="/work">
                <ButtonLink>View All Work</ButtonLink>
              </Link>
            </div>
          </section>
          <ContactCTA />
        </div>
      </Transitions>
    </div>
  );
}

export default Home;
